import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Checkbox,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
  round2Decimals,
  SelectEscuelasItem,
} from "../../../../Components/Items";
import { ORIGENES_FILTRO } from "../../VentasEcommerce/useVentasEcommerceAcciones";
import { FileExcelOutlined } from "@ant-design/icons";
import * as XLSXStyle from "xlsx-js-style";
import { ResponsiveLine } from "@nivo/line";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsivePie } from "@nivo/pie";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

const PALETA_INSUMOS = [
  "#2563EB",
  "#16A34A",
  "#F59E0B",
  "#DC2626",
  "#7C3AED",
  "#0891B2",
  "#DB2777",
  "#65A30D",
];

const colorMargenPct = (pct) => {
  if (pct < 0) return { bg: "#FFC7CE", color: "#9C0006" };
  if (pct <= 15) return { bg: "#FFEB9C", color: "#9C6500" };
  return { bg: "#C6EFCE", color: "#006100" };
};

class ReporteMargenVentas extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    objetoClientes: null,
    todasClientes: null,
    objetoUsuarios: null,
    todasUsuarios: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    dataReporte: null,
    todasVentas: [],
    dataGrafico: [],
    dataGraficoPastel: [],
    dataGraficoBarras: [],
    totalesPorMoneda: {},
    desglosarProductos: false,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });

    await Promise.all([
      axios.post(
        "clientes/selectClientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasClientes: res.data,
            objetoClientes: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.stringBuscar}
              </Option>
            )),
          });
        }
      }),

      axios.post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasUsuarios: res.data,
            objetoUsuarios: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre + " " + value.apellidoPaterno + " " + value.apellidoMaterno}
              </Option>
            )),
          });
        }
      }),

      axios.post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasProyectos: res.data,
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      }),

      axios.post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasUniadesDeNegocio: res.data,
            objetoUniadesDeNegocio: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(
                  value.nivel1 + value.nivel2 + value.nivel3 +
                  value.nivel4 + value.nivel5
                ) + " - " + value.nombre}
              </Option>
            )),
          });
        }
      }),

      axios.post(
        "canalesVenta/selectCanalesVenta",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasCanalesVenta: res.data.canalesVenta || [],
            objetoCanalesVenta: (res.data.canalesVenta || []).map((value) => (
              <Option value={value._id} key={value._id}>
                {value.codigo + " - " + value.nombre}
              </Option>
            )),
          });
        } else {
          message.error("Ha sucedido un error y no se cargaron los canales de venta");
        }
      }),
    ]);

    this.consultarReporteMargenVentas({
      periodo: [moment().subtract(1, "month"), moment()],
      clientes: 0,
      vendedores: 0,
      filtrarProyecto: 0,
      estadoFacturas: 5,
      excluirSinCosto: true,
      origenCosto: 1,
    });
  }

  crearGrafico(valueVentas, fechaInicial, fechaFinal, excluirSinCosto = true) {
    const fechaInicioMoment = moment(fechaInicial).locale("es");
    const fechaFinalMoment = moment(fechaFinal).locale("es");

    let unit = "day";
    let compareUnit = "date";
    if (fechaFinalMoment.diff(fechaInicioMoment, "days") <= 31) {
      unit = "day";
      compareUnit = "date";
    } else if (fechaFinalMoment.diff(fechaInicioMoment, "days") < 180) {
      unit = "week";
      compareUnit = "week";
    } else if (fechaFinalMoment.diff(fechaInicioMoment, "months") < 36) {
      unit = "month";
      compareUnit = "month";
    } else {
      unit = "year";
      compareUnit = "year";
    }
    const unitPlural = unit === "day" ? "days" : unit === "week" ? "weeks" : unit === "month" ? "months" : "years";

    const margenPct = [];
    const margenPctAcumulado = [];
    let subtotalAcumulado = 0;
    let costoAcumulado = 0;
    let fechaCambiante = moment(fechaInicioMoment);

    while (fechaFinalMoment.diff(fechaCambiante, unitPlural) !== -1) {
      // eslint-disable-next-line no-loop-func
      const ventasBucket = valueVentas.filter((venta) => {
        // Ventas sin costo capturado (no entregadas / solo insumos no
        // inventariables) se excluyen del calculo de margen: si se dejaran,
        // su ingreso entraria sin costo que lo compense y falsearia el %.
        if (excluirSinCosto && (venta.costoTotal || 0) <= 0) return false;
        if (isNaN(venta.fechaVenta)) {
          return moment(fechaCambiante).isSame(moment(venta.fechaVenta, "DD/MM/YYYY"), compareUnit);
        }
        return false;
      });

      let subtotalBucket = 0;
      let costoBucket = 0;
      ventasBucket.forEach((venta) => {
        const tc = venta.tipoDeCambio || 1;
        // costoTotal ya viene en pesos; solo el subtotal (en la moneda de la
        // venta) se normaliza a pesos con el tipo de cambio para poder
        // restarlos y sacar un margen que tenga sentido.
        subtotalBucket += (venta.subtotal || 0) * tc;
        costoBucket += venta.costoTotal || 0;
      });

      subtotalAcumulado += subtotalBucket;
      costoAcumulado += costoBucket;

      const pctBucket = subtotalBucket > 0 ? ((subtotalBucket - costoBucket) / subtotalBucket) * 100 : 0;
      const pctAcumulado = subtotalAcumulado > 0 ? ((subtotalAcumulado - costoAcumulado) / subtotalAcumulado) * 100 : 0;

      const etiqueta = moment(fechaCambiante).locale("es").format("DD/MM/YYYY");
      margenPct.push({ x: etiqueta, y: Number(pctBucket.toFixed(2)) });
      margenPctAcumulado.push({ x: etiqueta, y: Number(pctAcumulado.toFixed(2)) });

      fechaCambiante = moment(fechaCambiante).add(1, unit).locale("es");
    }

    this.setState({
      dataGrafico: [
        { id: "Margen %", color: "#16A34A", data: margenPct },
        { id: "Margen % Acumulado", color: "#86EFAC", data: margenPctAcumulado },
      ],
    });
  }

  crearGraficosInsumos(insumosMargen) {
    const topPastel = insumosMargen.filter((item) => item.utilidad > 0).slice(0, 8);
    const dataGraficoPastel = topPastel.map((item) => ({
      id: item.clave || item.descripcion || "Sin Clave",
      label: item.descripcion || item.clave || "Sin Descripción",
      value: item.utilidad,
    }));

    const topBarras = [...insumosMargen].slice(0, 10);
    topBarras.reverse();
    const dataGraficoBarras = topBarras.map((item) => ({
      insumo: (item.clave || "Sin Clave") + ` (${item.moneda})`,
      Margen: item.utilidad || 0,
      Costo: item.costoTotal || 0,
      descCompleta: item.descripcion,
    }));

    this.setState({ dataGraficoPastel, dataGraficoBarras });
  }

  consultarReporteMargenVentas(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeVentas/reporteMargenVentas",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const excluirSinCosto = values.excluirSinCosto !== false;
          this.crearGrafico(res.data.ventas, res.data.fechaInicial, res.data.fechaFinal, excluirSinCosto);
          if (res.data.desglosarProductos) {
            this.crearGraficosInsumos(res.data.insumosMargen || []);
          } else {
            this.setState({ dataGraficoPastel: [], dataGraficoBarras: [] });
          }
          const totalesPorMoneda = {};
          (res.data.ventas || []).filter(v => v.folio !== '').forEach(venta => {
            const moneda = venta.moneda || 'Sin Moneda';
            if (!totalesPorMoneda[moneda]) {
              totalesPorMoneda[moneda] = {
                subtotal: 0, totalImpuestos: 0, total: 0, totalRetenciones: 0,
                totalACobrar: 0, costo: 0, margen: 0,
              };
            }
            totalesPorMoneda[moneda].subtotal += venta.subtotal || 0;
            totalesPorMoneda[moneda].totalImpuestos += venta.totalImpuestos || 0;
            totalesPorMoneda[moneda].total += venta.total || 0;
            totalesPorMoneda[moneda].totalRetenciones += venta.totalRetenciones || 0;
            totalesPorMoneda[moneda].totalACobrar += venta.totalPagar || 0;
            totalesPorMoneda[moneda].costo += venta.costoTotal || 0;
            totalesPorMoneda[moneda].margen += venta.margen || 0;
          });
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasVentas: res.data.ventas,
            totalesPorMoneda,
            desglosarProductos: res.data.desglosarProductos,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      });
  }

  descargarExcel() {
    const FORMATO_CONTABILIDAD = '_-"$"* #,##0.00_-;-"$"* #,##0.00_-;_-"$"* "-"??_-;_-@_-';
    const FORMATO_PORCENTAJE = "0.00%";

    const border = {
      top: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
    };
    const headerStyle = {
      font: { bold: true, sz: 10, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "00BFD6" } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    };
    const textStyle = { border, alignment: { vertical: "center" } };
    const numeroStyle = { border, alignment: { horizontal: "right" } };
    const moneyStyle = { border, alignment: { horizontal: "right" }, numFmt: FORMATO_CONTABILIDAD };
    const dateStyle = { border, alignment: { horizontal: "center" } };

    // xlsx-js-style no infiere el tipo de celda cuando ya se le pasa un objeto
    // {v,s} armado - sin "t" explicito, escribe el numero como texto y Excel
    // no puede aplicarle el formato de moneda/porcentaje.
    const celdaMoneda = (valor) => (valor ? { v: valor, t: "n", s: moneyStyle } : { v: "", s: moneyStyle });
    const celdaTexto = (valor) => ({ v: valor === undefined || valor === null ? "" : valor, s: textStyle });
    const celdaNumero = (valor) => (typeof valor === "number" ? { v: valor, t: "n", s: numeroStyle } : celdaTexto(valor));
    const celdaFecha = (valor) => {
      const m = moment(valor, "DD/MM/YYYY", true);
      if (!m.isValid()) return celdaTexto(valor);
      return { v: new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)), t: "d", z: "dd/mm/yyyy", s: dateStyle };
    };
    const estiloMargenPct = (pct) => {
      let fill = "C6EFCE";
      let fuente = "006100";
      if (pct < 0) {
        fill = "FFC7CE";
        fuente = "9C0006";
      } else if (pct <= 15) {
        fill = "FFEB9C";
        fuente = "9C6500";
      }
      return {
        border,
        alignment: { horizontal: "right" },
        numFmt: FORMATO_PORCENTAJE,
        fill: { fgColor: { rgb: fill } },
        font: { color: { rgb: fuente }, bold: true },
      };
    };
    // valorPct llega null cuando el costo es 0 (venta sin entregar o insumo
    // no inventariable) - se deja la celda en blanco en vez de escribir un
    // 0%/100% que no refleja un margen real.
    const celdaSinCosto = { border, alignment: { horizontal: "right" }, fill: { fgColor: { rgb: "F2F2F2" } } };
    const celdaPorcentaje = (valorPct) =>
      valorPct === null || valorPct === undefined
        ? { v: "Sin costo", s: celdaSinCosto }
        : { v: valorPct / 100, t: "n", s: estiloMargenPct(valorPct) };

    const columnasFecha = [
      "Fecha", "Fecha Factura", "Fecha Timbrado", "Fecha Creacion", "Fecha Remision",
      "Fecha probable de pago", "Fecha Vencimiento",
    ];
    const columnasMoneda = new Set([
      "SubTotal", "Impuestos", "Retenciones", "Total", "Total A Cobrar", "Costo", "Margen",
      "Costo Unitario", "Margen Unitario",
      "Abonos", "Saldo", "Subtotal Insumo", "Precio Con Impuestos", "Total Insumo",
      "Precio Unitario", "Descuento",
    ]);

    let datosDescargar = [];

    if (this.state.desglosarProductos) {
      for (const valueVenta of this.state.todasVentas) {
        if (valueVenta.folio === '') {
          const venta = this.state.todasVentas.find(todasventas => todasventas.folio !== '' && todasventas._id.toString() === valueVenta._id.toString())
          datosDescargar.push({
            "Folio Factura": venta.folioFactura,
            "Serie Factura": venta.serieFactura,
            "Folio Remision": venta.folioRemision,
            "Serie Remision": venta.serieRemision,
            "Documento de Origen": venta.folioOrigen,
            "Codigo Cliente": venta.codigoCliente,
            "Clave Cliente": venta.claveCliente,
            "Proyecto": valueVenta.proyecto ? valueVenta.proyecto : '',
            Fecha: venta.fechaVenta,
            "Fecha Factura": venta.fechaFactura,
            "Fecha Timbrado": venta.fechaTimbrado,
            "Fecha Creacion": venta.fechaCreacion,
            "Fecha Remision": venta.fechaRemision,
            Cliente: venta.cliente,
            "Razon social": venta.razonSocial,
            "Codigo Insumo": valueVenta.codigoCliente,
            "Clave Insumo": valueVenta.claveCliente,
            "Cantidad": valueVenta.fechaVenta,
            "Entregado": valueVenta.entregado,
            "Descripcion": valueVenta.cliente,
            "Familia": valueVenta.familia,
            "Marca": valueVenta.marca,
            "Precio Unitario": valueVenta.total,
            "Descuento": valueVenta.descuento,
            "Costo Unitario": valueVenta.costoUnitario,
            "Margen Unitario": valueVenta.margenUnitario,
            Costo: valueVenta.costoTotal,
            Margen: valueVenta.margen,
            "% Margen": valueVenta.margenPct,
            "Subtotal Insumo": valueVenta.totalPagado,
            "Precio Con Impuestos": valueVenta.saldo,
            "Total Insumo": valueVenta.estado,
            "Fecha probable de pago": venta.fechaPago,
            "Metodo de Pago": venta.metodoPago,
            "Forma de Pago": venta.formaPago,
            "Fecha Vencimiento": venta.fechaVencimiento,
            "Dias Vencidos": venta.diasVencidos,
            SubTotal: venta.subtotal,
            Impuestos: venta.totalImpuestos,
            "Retenciones": venta.totalRetenciones,
            Total: venta.total,
            "Total A Cobrar": venta.totalPagar,
            Moneda: venta.moneda,
            "Tipo de Cambio": venta.tipoDeCambio,
            "Folio Fiscal": venta.folioFiscal,
            Estatus: venta.estatus,
            Abonos: venta.totalPagado,
            Saldo: venta.saldo,
            Estado: venta.estado,
            Vendedor: venta.vendedor,
            "Canal de Venta": venta.canalVenta,
            ...(this.props.ventaOnlineActivo && { "Tipo de Envío": venta.tipoEnvio }),
            ...(this.props.escuelaActivo && {
              Escuela: venta.escuela,
              Obligatorio: valueVenta.obligatorio,
            }),
            ...(this.props.equipoMedico && {
              Paciente: venta.paciente,
              Doctor: venta.doctor,
              "Cirugía": venta.cirugia,
            }),
          })
        }
      }
    } else {
      datosDescargar = this.state.todasVentas.map((valueVenta) => {
        let impuestosAgregar = {}
        if (Array.isArray(valueVenta.arrayImpuestos)) {
          valueVenta.arrayImpuestos.forEach(impuesto => {
            impuestosAgregar[impuesto.descripcionFactura] = round2Decimals(impuesto.totalImpuestos)
            columnasMoneda.add(impuesto.descripcionFactura);
          });
        }
        return {
          "Folio Factura": valueVenta.folioFactura,
          "Serie Factura": valueVenta.serieFactura,
          "Folio Remision": valueVenta.folioRemision,
          "Serie Remision": valueVenta.serieRemision,
          "Documento de Origen": valueVenta.folioOrigen,
          "Codigo Cliente": valueVenta.codigoCliente,
          "Clave Cliente": valueVenta.claveCliente,
          Fecha: valueVenta.fechaVenta,
          "Fecha Factura": valueVenta.fechaFactura,
          "Fecha Timbrado": valueVenta.fechaTimbrado,
          "Fecha Creacion": valueVenta.fechaCreacion,
          "Fecha Remision": valueVenta.fechaRemision,
          Cliente: valueVenta.cliente,
          "Proyecto": valueVenta.proyecto ? valueVenta.proyecto : '',
          "Razon social": valueVenta.razonSocial,
          "Fecha probable de pago": valueVenta.fechaPago,
          "Metodo de Pago": valueVenta.metodoPago,
          "Forma de Pago": valueVenta.formaPago,
          "Fecha Vencimiento": valueVenta.fechaVencimiento,
          "Dias Credito": valueVenta.diasCredito,
          "Orden de Compra": valueVenta.ordenDeCompra,
          SubTotal: valueVenta.subtotal,
          Impuestos: valueVenta.totalImpuestos,
          "Retenciones": valueVenta?.totalRetenciones,
          Total: valueVenta.total,
          "Total A Cobrar": valueVenta.totalPagar,
          Moneda: valueVenta.moneda,
          "Tipo de Cambio": valueVenta.tipoDeCambio,
          "Folio Fiscal": valueVenta.folioFiscal,
          Estatus: valueVenta.estado,
          Costo: valueVenta.costoTotal,
          Margen: valueVenta.margen,
          "% Margen": valueVenta.margenPct,
          Abonos: valueVenta.totalPagado,
          Saldo: valueVenta.saldo,
          Estado: valueVenta.estado,
          "Entregado": valueVenta.estadoEntregado,
          Vendedor: valueVenta.vendedor,
          "Canal de Venta": valueVenta.canalVenta,
          ...(this.props.ventaOnlineActivo && { "Tipo de Envío": valueVenta.tipoEnvio }),
          ...(this.props.escuelaActivo && { Escuela: valueVenta.escuela }),
          ...(this.props.equipoMedico && {
            Paciente: valueVenta.paciente,
            Doctor: valueVenta.doctor,
            "Cirugía": valueVenta.cirugia,
          }),
          ...impuestosAgregar,
        };
      });
    }

    // Orden estable de columnas: union de llaves en orden de primera aparicion
    // (algunas filas traen columnas de impuestos distintas entre si).
    const columnas = [];
    const vistas = new Set();
    datosDescargar.forEach((fila) => {
      Object.keys(fila).forEach((llave) => {
        if (!vistas.has(llave)) {
          vistas.add(llave);
          columnas.push(llave);
        }
      });
    });

    const filaEncabezado = columnas.map((titulo) => ({ v: titulo, s: headerStyle }));
    const filas = [filaEncabezado];

    datosDescargar.forEach((fila) => {
      filas.push(
        columnas.map((titulo) => {
          const valor = fila[titulo];
          if (titulo === "% Margen") return celdaPorcentaje(valor);
          if (columnasFecha.includes(titulo)) return celdaFecha(valor);
          if (columnasMoneda.has(titulo)) return celdaMoneda(valor);
          if (typeof valor === "number") return celdaNumero(valor);
          return celdaTexto(valor);
        })
      );
    });

    const worksheet = XLSXStyle.utils.aoa_to_sheet(filas);
    worksheet["!cols"] = columnas.map((titulo) =>
      ["Cliente", "Descripcion", "Razon social"].includes(titulo) ? { wch: 28 } : { wch: 16 }
    );
    const workbook = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Margen De Ventas");
    XLSXStyle.writeFile(workbook, `Reporte_Margen_De_Ventas_${moment().locale("es").format("L")}.xlsx`);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  calcularRangoPeriodo(preset) {
    switch (preset) {
      case "hoy":
        return [moment().startOf("day"), moment().endOf("day")];
      case "ayer":
        return [
          moment().subtract(1, "day").startOf("day"),
          moment().subtract(1, "day").endOf("day"),
        ];
      case "semana":
        return [moment().startOf("week"), moment().endOf("week")];
      case "mes":
        return [moment().startOf("month"), moment().endOf("month")];
      case "mesPasado":
        return [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ];
      case "trimestre":
        return [moment().startOf("quarter"), moment().endOf("quarter")];
      case "anio":
        return [moment().startOf("year"), moment().endOf("year")];
      case "anioPasado":
        return [
          moment().subtract(1, "year").startOf("year"),
          moment().subtract(1, "year").endOf("year"),
        ];
      case "ultimos30":
      default:
        return [moment().subtract(1, "month"), moment()];
    }
  }

  onChangePeriodoPreset = (preset) => {
    if (preset === "personalizado") return;
    const rango = this.calcularRangoPeriodo(preset);
    this.formRef.current?.setFieldsValue({ periodo: rango });
  };

  render() {
    const columns = [
      {
        title: "Folio",
        dataIndex: "folio",
        key: "folio",
        sorter: (a, b) => (a.folio < b.folio ? -1 : a.folio > b.folio ? 1 : 0),
        buscar: "folio",
        ellipsis: true,
      },
      {
        title: "Fecha Remision",
        dataIndex: "fechaRemision",
        key: "fechaRemision",
        sorter: (a, b) => {
          if (moment(a.fechaRemision, "DD/MM/YYYY") < moment(b.fechaRemision, "DD/MM/YYYY")) return -1;
          if (moment(a.fechaRemision, "DD/MM/YYYY") > moment(b.fechaRemision, "DD/MM/YYYY")) return 1;
          return 0;
        },
        buscar: "fechaRemision",
        ellipsis: true,
      },
      {
        title: "Fecha Factura",
        dataIndex: "fechaFactura",
        key: "fechaFactura",
        sorter: (a, b) => {
          if (moment(a.fechaFactura, "DD/MM/YYYY") < moment(b.fechaFactura, "DD/MM/YYYY")) return -1;
          if (moment(a.fechaFactura, "DD/MM/YYYY") > moment(b.fechaFactura, "DD/MM/YYYY")) return 1;
          return 0;
        },
        buscar: "fechaFactura",
        ellipsis: true,
      },
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        sorter: (a, b) => (a.cliente < b.cliente ? -1 : a.cliente > b.cliente ? 1 : 0),
        buscar: "cliente",
        ellipsis: true,
      },
      {
        title: "Total",
        dataIndex: "totalPagar",
        key: "totalPagar",
        sorter: (a, b) => a.totalPagar - b.totalPagar,
        buscar: "totalPagar",
        render: (value) => dineroDisabledMask(value),
        align: "right",
        ellipsis: true,
      },
      {
        title: "Costo",
        dataIndex: "costoTotal",
        key: "costoTotal",
        sorter: (a, b) => a.costoTotal - b.costoTotal,
        buscar: "costoTotal",
        render: (value) => dineroDisabledMask(value),
        align: "right",
        ellipsis: true,
      },
      {
        title: "Margen",
        dataIndex: "margen",
        key: "margen",
        sorter: (a, b) => a.margen - b.margen,
        render: (value) => dineroDisabledMask(value),
        align: "right",
        ellipsis: true,
      },
      {
        title: "% Margen",
        dataIndex: "margenPct",
        key: "margenPct",
        sorter: (a, b) => (a.margenPct ?? -Infinity) - (b.margenPct ?? -Infinity),
        align: "right",
        ellipsis: true,
        render: (value) => {
          // margenPct viene null cuando el costo es 0 (venta sin entregar o
          // insumo no inventariable) - no hay costo real con que calcular un
          // % de margen, asi que no se muestra como si fuera 0% o 100%.
          if (value === null || value === undefined) {
            return (
              <span style={{ color: "#999", fontStyle: "italic" }}>Sin costo</span>
            );
          }
          const { bg, color } = colorMargenPct(value);
          return (
            <span
              style={{
                backgroundColor: bg,
                color,
                padding: "2px 8px",
                borderRadius: 4,
                fontWeight: 600,
                display: "inline-block",
                minWidth: 60,
                textAlign: "right",
              }}
            >
              {value.toFixed(2)}%
            </span>
          );
        },
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        sorter: (a, b) => (a.estado < b.estado ? -1 : a.estado > b.estado ? 1 : 0),
        buscar: "estado",
        ellipsis: true,
      },
      {
        title: "Vendedor",
        dataIndex: "vendedor",
        key: "vendedor",
        sorter: (a, b) => (a.vendedor < b.vendedor ? -1 : a.vendedor > b.vendedor ? 1 : 0),
        buscar: "vendedor",
        ellipsis: true,
      },
      ...(this.props.ventaOnlineActivo
        ? [{ title: "Tipo de Envío", dataIndex: "tipoEnvio", key: "tipoEnvio", buscar: "tipoEnvio", ellipsis: true }]
        : []),
      ...(this.props.escuelaActivo
        ? [{ title: "Escuela", dataIndex: "escuela", key: "escuela", buscar: "escuela", ellipsis: true }]
        : []),
      ...(this.props.equipoMedico
        ? [
            { title: "Paciente", dataIndex: "paciente", key: "paciente", ellipsis: true },
            { title: "Doctor", dataIndex: "doctor", key: "doctor", ellipsis: true },
            { title: "Cirugía", dataIndex: "cirugia", key: "cirugia", ellipsis: true },
          ]
        : []),
    ];

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteMargenVentas"
          onFinish={this.consultarReporteMargenVentas.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Margen De Ventas"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>,
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <Row gutter={8} style={{ flexWrap: "nowrap" }}>
                    <Col flex="none">
                      <FormItem name="periodoPreset" noStyle initialValue="ultimos30">
                        <SelectItem width={160} onChange={this.onChangePeriodoPreset}>
                          <Option value="hoy">Hoy</Option>
                          <Option value="ayer">Ayer</Option>
                          <Option value="semana">Esta semana</Option>
                          <Option value="mes">Este mes</Option>
                          <Option value="mesPasado">Mes pasado</Option>
                          <Option value="trimestre">Este trimestre</Option>
                          <Option value="anio">Este año</Option>
                          <Option value="anioPasado">Año pasado</Option>
                          <Option value="ultimos30">Últimos 30 días</Option>
                          <Option value="personalizado">Personalizado</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col flex="auto">
                      <FormItem name="periodo" required noStyle>
                        <RangePickerItem
                          onChange={() =>
                            this.formRef.current?.setFieldsValue({ periodoPreset: "personalizado" })
                          }
                        />
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Clientes">
                  <FormItem name="clientes" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Clientes">
                      {this.state.objetoClientes}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Vendedores">
                  <FormItem name="vendedores" margin noStyle>
                    <SelectItem width="90%" mode="multiple" placeholder="Vendedores">
                      {this.state.objetoUsuarios}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem name="filtrarProyecto" required noStyle initialValue={0}>
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>Niguno</Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto = getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem width="90%" placeholder="Proyectos" mode="multiple">
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem required margin name="unidadDeNegocioId" noStyle>
                                <SelectItem width="90%" placeholder="Unidades de Negocio">
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="6" key="6" forceRender tab="Canales de Venta">
                  <FormItem name="canalesVenta" margin noStyle>
                    <SelectItem width="90%" mode="multiple" placeholder="Canales de Venta">
                      {this.state.objetoCanalesVenta}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                {this.props.escuelaActivo && (
                  <TabPane tabKey="7" key="7" forceRender tab="Escuela">
                    <FormItem name="escuelaId" noStyle margin>
                      <SelectEscuelasItem
                        width="90%"
                        allowClear
                        placeholder="Escuela"
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                      />
                    </FormItem>
                  </TabPane>
                )}
                {this.props.ventaOnlineActivo && (
                  <TabPane tabKey="8" key="8" forceRender tab="E-commerce">
                    <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                      <Col span={8}>
                        <FormItem name="ventaOnline" valuePropName="checked" margin noStyle>
                          <Checkbox>Solo Ventas Online</Checkbox>
                        </FormItem>
                      </Col>
                      <Col span={16}>
                        <FormItem name="tiposEnvio" noStyle margin>
                          <SelectItem width="90%" mode="multiple" placeholder="Tipo de Envío">
                            {ORIGENES_FILTRO.map((origen) => (
                              <Option value={origen.key} key={origen.key}>
                                {origen.label}
                              </Option>
                            ))}
                          </SelectItem>
                        </FormItem>
                      </Col>
                    </Row>
                  </TabPane>
                )}
                <TabPane tabKey="5" key="5" forceRender tab="Detalles">
                  <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                    <Col span={8}>
                      <FormItem
                        label="Estado"
                        name="estadoFacturas"
                        required
                        initialValue={5}
                        style={{ marginBottom: 0 }}
                      >
                        <SelectItem placeholder="Filtrar Por">
                          <Option default value={5}>Activas</Option>
                          <Option value={4}>Por Cobrar</Option>
                          <Option value={3}>Cobrada</Option>
                          <Option value={2}>Vencida</Option>
                          <Option value={1}>Canceladas</Option>
                          <Option value={0}>Todas (Activas y Canceladas)</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem
                        label="Desglosar Productos"
                        name="desglosarProductos"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem
                        label="Excluir Insumos Sin Costo"
                        name="excluirSinCosto"
                        valuePropName="checked"
                        initialValue={true}
                        margin
                        tooltip="Ventas sin entregar o insumos no inventariables pueden tener costo $0. Activado (recomendado), no se cuentan para el % de margen en las gráficas ni en el Excel. Desactívalo para incluirlos con su costo real de $0 (se verán con 100% de margen)."
                      >
                        <Checkbox />
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem
                        label="Origen Del Costo"
                        name="origenCosto"
                        required
                        initialValue={1}
                        style={{ marginBottom: 0 }}
                        tooltip="Costo Contable: el costo real de inventario congelado en la venta al entregarla (vale $0 si la venta no se ha entregado o el insumo no es inventariable). Costo Del Insumo: el costo guardado en el catalogo del insumo por la cantidad vendida, disponible aunque la venta no se haya entregado."
                      >
                        <SelectItem placeholder="Origen Del Costo">
                          <Option default value={1}>Costo Contable (Inventario)</Option>
                          <Option value={2}>Costo Del Insumo (Catalogo)</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>

            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingBottom: 35,
                marginTop: 10,
                marginBottom: 10,
                height: 420,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <h1 style={{ fontSize: 18, margin: "0 0 10px 0" }}>Margen % En El Tiempo</h1>
              <ResponsiveLine
                data={this.state.dataGrafico}
                margin={{ top: 15, right: 20, bottom: 70, left: 60 }}
                enableSlices="x"
                useMesh={true}
                yFormat={(e) => `${Number(e).toFixed(2)}%`}
                xScale={{ type: "point" }}
                yScale={{ type: "linear", stacked: false, reverse: false }}
                curve="monotoneX"
                lineWidth={2}
                pointSize={5}
                pointBorderWidth={1}
                pointColor={{ theme: "background" }}
                pointBorderColor={{ from: "serieColor" }}
                colors={["#16A34A", "#86EFAC"]}
                colorBy="index"
                markers={[
                  {
                    axis: "y",
                    value: 0,
                    lineStyle: { stroke: "#94A3B8", strokeWidth: 1, strokeDasharray: "4 4" },
                  },
                ]}
                axisTop={null}
                axisRight={null}
                axisBottom={{
                  tickSize: 5,
                  tickPadding: 8,
                  tickRotation: 45,
                  tickValues: (this.state.dataGrafico?.[0]?.data || [])
                    .map((d) => d.x)
                    .filter((_, i) => i % 2 === 0),
                }}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 8,
                  format: (v) => `${v}%`,
                }}
                enableGridX={false}
                legends={[
                  {
                    anchor: "top",
                    direction: "row",
                    translateX: 0,
                    translateY: -15,
                    itemWidth: 160,
                    itemHeight: 18,
                    symbolSize: 10,
                    symbolShape: "circle",
                    itemOpacity: 0.85,
                    effects: [{ on: "hover", style: { itemOpacity: 1 } }],
                  },
                ]}
              />
            </div>

            {this.state.desglosarProductos && this.state.dataGraficoPastel.length > 0 && (
              <div
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  marginBottom: 10,
                  borderRadius: 5,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <Row gutter={16}>
                  <Col span={12}>
                    <h1 style={{ fontSize: 18, margin: "0 0 10px 0" }}>Insumos De Mayor Margen</h1>
                    <div style={{ height: 380 }}>
                      <ResponsivePie
                        data={this.state.dataGraficoPastel}
                        margin={{ top: 20, right: 90, bottom: 60, left: 90 }}
                        innerRadius={0.5}
                        padAngle={1}
                        cornerRadius={3}
                        activeOuterRadiusOffset={6}
                        colors={PALETA_INSUMOS}
                        borderWidth={1}
                        borderColor={{ from: "color", modifiers: [["darker", 0.4]] }}
                        arcLinkLabelsSkipAngle={10}
                        arcLinkLabelsTextColor="#333333"
                        arcLabelsSkipAngle={10}
                        valueFormat={(v) => dineroDisabledMask(v)}
                        tooltip={({ datum }) => (
                          <div
                            style={{
                              padding: "10px 14px",
                              background: "#fff",
                              border: "1px solid #e2e8f0",
                              borderRadius: 6,
                              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                            }}
                          >
                            <strong style={{ fontSize: 13 }}>{datum.label}</strong>
                            <br />
                            <span style={{ color: datum.color, fontWeight: 600, fontSize: 14 }}>
                              Margen: {dineroDisabledMask(datum.value)}
                            </span>
                          </div>
                        )}
                        legends={[
                          {
                            anchor: "bottom",
                            direction: "row",
                            translateY: 56,
                            itemWidth: 90,
                            itemHeight: 18,
                            symbolSize: 12,
                            itemsSpacing: 4,
                          },
                        ]}
                      />
                    </div>
                  </Col>
                  <Col span={12}>
                    <h1 style={{ fontSize: 18, margin: "0 0 10px 0" }}>Margen Por Producto</h1>
                    <div style={{ height: 380 }}>
                      <ResponsiveBar
                        data={this.state.dataGraficoBarras}
                        keys={["Margen", "Costo"]}
                        indexBy="insumo"
                        margin={{ right: 130, bottom: 50, left: 100 }}
                        padding={0.4}
                        layout="horizontal"
                        valueScale={{ type: "linear" }}
                        indexScale={{ type: "band", round: true }}
                        colors={["#16A34A", "#DC2626"]}
                        borderRadius={3}
                        borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{
                          tickSize: 5,
                          tickPadding: 5,
                          tickRotation: 0,
                          legend: "Monto ($)",
                          legendPosition: "middle",
                          legendOffset: 40,
                          format: (v) => `$${v >= 1000 ? v / 1000 + "k" : v}`,
                        }}
                        axisLeft={{
                          tickSize: 5,
                          tickPadding: 5,
                          tickRotation: 0,
                          legend: "Clave Insumo",
                          legendPosition: "middle",
                          legendOffset: -80,
                        }}
                        enableLabel={false}
                        legends={[
                          {
                            dataFrom: "keys",
                            anchor: "bottom-right",
                            direction: "column",
                            justify: false,
                            translateX: 120,
                            translateY: 0,
                            itemsSpacing: 2,
                            itemWidth: 100,
                            itemHeight: 20,
                            itemDirection: "left-to-right",
                            itemOpacity: 0.85,
                            symbolSize: 20,
                            symbolShape: "circle",
                            effects: [{ on: "hover", style: { itemOpacity: 1 } }],
                          },
                        ]}
                        tooltip={({ id, value, color, data }) => (
                          <div
                            style={{
                              padding: "10px 14px",
                              background: "#fff",
                              border: "1px solid #e2e8f0",
                              borderRadius: 6,
                              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                            }}
                          >
                            <strong style={{ fontSize: 13 }}>{data.insumo} - {data.descCompleta}</strong>
                            <br />
                            <span style={{ color, fontWeight: 600, fontSize: 14 }}>{id}: {dineroDisabledMask(value)}</span>
                          </div>
                        )}
                        role="application"
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            )}

            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginBottom: 10,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              {Object.entries(this.state.totalesPorMoneda).map(([moneda, totales], idx, arr) => {
                const pctGeneral = totales.subtotal > 0 ? (totales.margen / totales.subtotal) * 100 : 0;
                const { bg, color } = colorMargenPct(pctGeneral);
                return (
                  <div key={moneda} style={{ marginBottom: arr.length > 1 && idx < arr.length - 1 ? 8 : 0 }}>
                    {arr.length > 1 && (
                      <p style={{ margin: "0 0 2px 8px", fontWeight: 700, fontSize: 13, color: "#00BFD6" }}>
                        {moneda}
                      </p>
                    )}
                    <Row>
                      <Col span={4} style={{ textAlign: "center" }}>
                        <p style={{ margin: 0 }}>{arr.length === 1 ? `Subtotal (${moneda})` : "Subtotal"}</p>
                        <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(totales.subtotal)}</h1>
                      </Col>
                      <Col span={1} style={{ textAlign: "center" }}><h1 style={{ fontSize: 20 }}>-</h1></Col>
                      <Col span={4} style={{ textAlign: "center" }}>
                        <p style={{ margin: 0 }}>Costo</p>
                        <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(totales.costo)}</h1>
                      </Col>
                      <Col span={1} style={{ textAlign: "center" }}><h1 style={{ fontSize: 20 }}>=</h1></Col>
                      <Col span={4} style={{ textAlign: "center" }}>
                        <p style={{ margin: 0 }}>Margen</p>
                        <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(totales.margen)}</h1>
                      </Col>
                      <Col span={1} style={{ textAlign: "center" }}><h1 style={{ fontSize: 20 }}>|</h1></Col>
                      <Col span={4} style={{ textAlign: "center" }}>
                        <p style={{ margin: 0 }}>% Margen</p>
                        <h1 style={{ fontSize: 15, backgroundColor: bg, color, display: "inline-block", padding: "0 10px", borderRadius: 4 }}>
                          {pctGeneral.toFixed(2)}%
                        </h1>
                      </Col>
                    </Row>
                    {arr.length > 1 && idx < arr.length - 1 && (
                      <hr style={{ margin: "6px 0", borderColor: "#f0f0f0" }} />
                    )}
                  </div>
                );
              })}
            </div>

            <TableItem
              onRow={(record) => ({
                onDoubleClick: () => {
                  this.props.history.push("/panel/verVenta", { id: record._id });
                },
              })}
              rowKey={(value) => value._id.toString() + Math.random()}
              columns={columns}
              dataSource={this.state.todasVentas}
              size="small"
              pagination={false}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    equipoMedico: state.empresa.equipoMedico,
    escuelaActivo: !!state.empresa.escuela,
    ventaOnlineActivo: !!state.empresa.ventaOnline,
  };
};

export default connect(mapStateToProps)(ReporteMargenVentas);
